import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {   NbThemeService } from '@nebular/theme';



@Component({
  selector: 'app-watchers-layout',
  templateUrl: './watchers-layout.component.html',
  styleUrls: ['./watchers-layout.component.scss']
})
export class WatchersLayoutComponent {

  constructor(
    private themeService: NbThemeService
  ) { 
    this.themeService.changeTheme(localStorage.getItem('theme') || 'default')

   }

}
